import { PetState } from './petStates.js'

const CAT_BASE_PATH = '/pets/cat'

export const PET_RUNTIME_RENDERERS = Object.freeze({
  LOTTIE: 'lottie',
  SPINE: 'spine',
  SPRITE_SHEET: 'spriteSheet',
  THREE_D: 'three',
})

export const CAT_SPRITE_MANIFEST = Object.freeze({
  renderer: PET_RUNTIME_RENDERERS.SPRITE_SHEET,
  states: {
    [PetState.IDLE]: {
      alt: 'idle',
      fps: 8,
      frameHeight: 160,
      frames: 6,
      frameWidth: 160,
      loop: true,
      src: `${CAT_BASE_PATH}/idle.png`,
    },
    [PetState.HAPPY]: {
      alt: 'happy',
      fps: 10,
      frameHeight: 160,
      frames: 6,
      frameWidth: 160,
      loop: true,
      src: `${CAT_BASE_PATH}/happy.png`,
    },
    [PetState.LEARNING]: {
      alt: 'study',
      fps: 8,
      frameHeight: 160,
      frames: 6,
      frameWidth: 160,
      loop: true,
      src: `${CAT_BASE_PATH}/study.png`,
    },
    [PetState.SLEEPING]: {
      alt: 'sleep',
      fps: 5,
      frameHeight: 160,
      frames: 6,
      frameWidth: 160,
      loop: true,
      src: `${CAT_BASE_PATH}/sleep.png`,
    },
    [PetState.CELEBRATE]: {
      alt: 'celebrate',
      fps: 12,
      frameHeight: 160,
      frames: 6,
      frameWidth: 160,
      loop: true,
      src: `${CAT_BASE_PATH}/celebrate.png`,
    },
  },
})
